import {useBanners} from 'api/queries';
import {Banners} from 'components/pages/main';
import {useRouter} from 'next/router';
import {FC} from 'react';
import {QueryKeyEnum} from 'types';

interface IProps {
  categorySlug: string;
}

export const CategoryBanner: FC<IProps> = ({categorySlug = ''}) => {
  const {locale} = useRouter();
  const {data: banners = []} = useBanners(
    [QueryKeyEnum.BANNERS, categorySlug, locale],
    {
      category__slug: categorySlug,
    },
    {},
  );

  if (!banners) return null;

  return <Banners banners={banners} />;
};
